export default __webpack_public_path__ + "static/media/quantstamp.139f85fe.svg";